// extracted by mini-css-extract-plugin
export default {"header":"styles_header__7oHGD","light":"styles_light__qTxo2","dark":"styles_dark__evO2E","left":"styles_left__4mrOI","right":"styles_right__EaotQ","date":"styles_date__gFMuZ"};